(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AP", [], factory);
	else if(typeof exports === 'object')
		exports["AP"] = factory();
	else
		root["AP"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 